import { X } from 'lucide-react';

interface IconCloseButtonProps {
  ariaLabel?: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  title?: string;
}

const IconCloseButton: React.FC<IconCloseButtonProps> = ({
  ariaLabel = 'Close',
  onClick,
  title,
}) => {
  return (
    <button
      aria-label={ariaLabel}
      className="inline-flex items-center justify-center size-[24px] cursor-pointer rounded-[4px] text-black hover:bg-black/5 focus-visible:bg-black/5 focus-visible:outline-none"
      onClick={onClick}
      title={title ?? ariaLabel}
      type="button"
    >
      <X aria-hidden="true" size={16} strokeWidth={1.75} />
    </button>
  );
};

export default IconCloseButton;
